import type { ContratoDoCliente, StatusDoContrato } from '@nebula/shared/services'
import { formatarDiaDoVoucher, rotuloDoEscopo } from '@nebula/shared/utils'
import { formatCalendarDate, formatDate } from '@nebula/shared/utils/format'

/** Rótulos dos contratos especiais na tela do cliente (#1091 F3). */
export const ROTULO_DA_MODALIDADE: Record<ContratoDoCliente['contract_type'], string> = {
  resource_block: 'Bloco de recursos',
  simple_discount: 'Desconto',
  voucher: 'Voucher de desconto',
}

export const ROTULO_DO_STATUS: Record<StatusDoContrato, string> = {
  active: 'Ativo',
  cancelled: 'Cancelado',
  expired: 'Expirado',
}

export const COR_DO_STATUS: Record<StatusDoContrato, string> = {
  active: 'bg-green-100 text-green-800',
  cancelled: 'bg-red-100 text-red-800',
  expired: 'bg-gray-100 text-gray-800',
}

export function escopoDoContrato(c: ContratoDoCliente): string {
  // o voucher não tem escopo de produto: cobre o consumo da plataforma (#1107, D5)
  if (c.contract_type === 'voucher') return 'Consumo da plataforma'
  return rotuloDoEscopo(c.contract_type, c.escopo, {
    tipo: c.escopo_tipo,
    produtoNome: c.escopo_produto_nome,
  })
}

export function vigenciaDoContrato(c: ContratoDoCliente): string {
  // o voucher grava a vigência no dia de Brasília (é lá que a competência vira); os outros, em
  // meia-noite UTC
  const dia = c.contract_type === 'voucher' ? formatarDiaDoVoucher : formatCalendarDate
  const inicio = dia(c.start_date)
  if (c.status === 'cancelled' && c.cancelled_at) {
    return `${inicio} → cancelado em ${formatDate(c.cancelled_at, false)}`
  }
  return c.end_date ? `${inicio} → ${dia(c.end_date)}` : `${inicio} → sem data de fim`
}

/** "10.00" → "10%"; "12.50" → "12,5%" */
export function rotuloDoPercentual(pct: string | null | undefined): string {
  if (pct === null || pct === undefined) return '—'
  return `${Number(pct).toLocaleString('pt-BR', { maximumFractionDigits: 2 })}%`
}
